import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";
import { openWhatsApp } from "@/lib/whatsapp";

const POLICIES = [
  { label: "Privacy Policy", type: "privacy" },
  { label: "Terms & Conditions", type: "terms" },
  { label: "Shipping Policy", type: "shipping" },
  { label: "Cancellation Policy", type: "cancellation" },
  { label: "Refund Policy", type: "refund" },
];

export default function Footer() {
  const { settings } = useSettings();
  const brand = settings?.brand || {};
  const contact = settings?.contact || {};

  return (
    <footer className="bg-forest-950 text-cream/90 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="font-serif font-extrabold text-3xl text-cream">{brand.name || "AREEBA"}</div>
          <div className="text-wheat font-serif text-lg mt-1">{brand.product_name || "Multigrain Aata"}</div>
          <p className="text-wheat/80 italic mt-2">{brand.tagline || "Har Roti Mein Tazgi."}</p>
        </div>

        <div>
          <h4 className="font-semibold text-cream mb-4 uppercase text-xs tracking-wider">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/" className="hover:text-wheat">Home</Link></li>
            <li><Link to="/product/areeba-multigrain-aata" className="hover:text-wheat">Shop</Link></li>
            <li><Link to="/about" className="hover:text-wheat">About</Link></li>
            <li><Link to="/faq" className="hover:text-wheat">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-wheat">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-cream mb-4 uppercase text-xs tracking-wider">Policies</h4>
          <ul className="space-y-2.5 text-sm">
            {POLICIES.map((p) => (
              <li key={p.type}>
                <Link to={`/policy/${p.type}`} className="hover:text-wheat" data-testid={`footer-policy-${p.type}`}>
                  {p.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-cream mb-4 uppercase text-xs tracking-wider">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-2.5"><MapPin size={16} className="text-wheat shrink-0 mt-0.5" /><span>{contact.address}</span></li>
            {contact.phone && <li className="flex gap-2.5"><Phone size={16} className="text-wheat shrink-0" /><span>{contact.phone}</span></li>}
            {contact.email && <li className="flex gap-2.5"><Mail size={16} className="text-wheat shrink-0" /><span className="break-all">{contact.email}</span></li>}
            <li>
              <button onClick={() => openWhatsApp()} className="inline-flex items-center gap-2 text-whatsapp font-semibold" data-testid="footer-whatsapp">
                <MessageCircle size={16} /> Order on WhatsApp
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-cream/60">
          <p>© {new Date().getFullYear()} {brand.name || "Areeba"}. Proprietor: Gajala Parveen. All rights reserved.</p>
          <p><Link to="/admin" className="hover:text-wheat" data-testid="footer-admin-link">Business Login</Link></p>
        </div>
      </div>
    </footer>
  );
}
